import { logI } from "@blacknut/logging/dist";
import { DEFAULT_API_VERSION } from "../api/ApiService";
import { ClientDeviceType, SupportedOS, UserAgent } from "../model";
import UAParser from "ua-parser-js";

const LOGGING_TAG = "UserAgent";
export const isTouchDevice = () => {
  return ("ontouchstart" in window || navigator.maxTouchPoints > 0) && !isWebOS();
};

export const isPhone = () => {
  return (
    Math.min(window.innerWidth, window.innerHeight) < 500 &&
    isTouchDevice() &&
    !matchMedia("(pointer:fine)").matches
  );
};
export const is_iOS = () => {
  return /iPhone|iPad|iPod|Mac/i.test(navigator.userAgent) && isTouchDevice();
};

export const is_Mac = () => {
  return /Macintosh/i.test(navigator.userAgent);
};

export const isSmartTV = () => {
  return /Smart-TV|SmartTV|Color|STB|STV-IPTV/i.test(navigator.userAgent);
};

export const isTV = () => {
  return isSmartTV() || isWebOS() || isTizen() || isFetchTV();
};

export const isWebOS = () => {
  if (navigator.userAgent) {
    const ua = navigator.userAgent.toLowerCase();
    return (
      /webos|web0s/i.test(ua) ||
      (ua.indexOf("smarttv") !== -1 && ua.indexOf("colt") !== -1)
    );
  }
  return false;
};

export const isTizen = () => {
  if ("tizen" in window) {
    return true;
  } else if (navigator.userAgent) {
    return navigator.userAgent.toLowerCase().indexOf("tizen") !== -1;
  } else {
    return false;
  }
};

export const isVidaa = () => {
  if (navigator.userAgent) {
    return /(hisense|vidaa)/i.test(navigator.userAgent);
  } else {
    return false;
  }
};

export const isTitanOS = () => {
  if (navigator.userAgent) {
    return /titanos/i.test(navigator.userAgent);
  } else {
    return false;
  }
};

export const isFetchTV = () => {
  if (navigator.userAgent) {
    return /fetchtv/i.test(navigator.userAgent);
  } else {
    return false;
  }
};

export const configureUserAgent: () => UserAgent = () => {
  const parser = new UAParser(navigator.userAgent);
  logI(LOGGING_TAG, "Parsed UA: %o", parser.getResult());

  const platform =
    (navigator as any)?.userAgentData?.platform || navigator?.platform || "unknown";
  const idx = platform.indexOf(" ");
  let os: SupportedOS = idx === -1 ? platform : platform.substring(0, idx);
  if (is_iOS()) {
    os = SupportedOS.iOS;
  } else if (isVidaa()) {
    os = SupportedOS.Vidaa;
  } else if (isTitanOS()) {
    os = SupportedOS.Titanos;
  } else if (isWebOS()) {
    os = SupportedOS.Webos;
  } else if (isTizen()) {
    os = SupportedOS.Tizen;
  } else if ((os as string) === "MacIntel") {
    os = SupportedOS.Mac;
  } else if (parser.getResult().os.name?.match(/Chrom(e|ium)/i)) {
    os = SupportedOS.ChromeOS;
  } else {
    os = os as unknown as SupportedOS;
  }

  let deviceType: "DESKTOP" | "MOBILE" | "TABLET" | "TV" = "DESKTOP";
  let client: ClientDeviceType = ClientDeviceType.DESKTOP;
  if (os === SupportedOS.ChromeOS) {
    client = ClientDeviceType.DESKTOP;
  } else if (isTV()) {
    deviceType = "TV";
    client = ClientDeviceType.TV;
  } else if (isPhone() && os !== "Windows" && os !== "Linux") {
    deviceType = "MOBILE";
    client = ClientDeviceType.PHONE;
  } else if (
    isTouchDevice() &&
    os !== "Windows" &&
    os !== "Linux" &&
    !matchMedia("(pointer:fine)").matches
  ) {
    deviceType = "TABLET";
    client = ClientDeviceType.TABLET;
  }

  // fix for https://blacknut.atlassian.net/browse/CA-4830

  return {
    deviceType,
    os,
    client,
    apiVersion: DEFAULT_API_VERSION,
    clientVersion: "1.0.0",
    brand: parser.getResult().device.vendor,
    model: parser.getResult().device.model,
  };
};
